module.exports = __webpack_public_path__ + "static/a-titan-raises-the-bar-index-thumbnails-1920x1080-f3da0f3ace1e95a5693ff2d3ab856142.jpg";